export const LINK_IS_INVALID_FLAG = '链接已失效';
